import { EndpointPermission, Permission } from "../domain/Permission.model";

export const createAdapterPermission = (permission: EndpointPermission) => {
    const formattedPermission: Permission = {
        id: permission.id,
        name: permission.name,
    };
    return formattedPermission;
}